import { Screen } from '@modules/shared/services/window.service';

import { MediaSetting } from '../media-setting.interface';

export const Equal4SectionImageStyle: MediaSetting[] = [
  { screen: Screen.XXXS, key: '2_1_568', width: 568, height: 284, ratio: 2 },
  { screen: Screen.MD, key: '3_2_300', width: 300, height: 200, ratio: 1.5 },
];
